import React from 'react';
import { FieldInputProps, FieldProps, useFormikContext } from 'formik';
import { RadioGroup } from 'rsuite';

export interface RadioGroupFieldProps extends FieldInputProps<number>, FieldProps { }

function RadioGroupField({ field, onChange, ...props }: RadioGroupFieldProps) {
  const formik = useFormikContext();
  return (
    <RadioGroup
      name={field.name}
      value={field.value}
      onChange={(value) => {
        onChange?.(value);
        formik.setFieldValue(field.name, value);
      }}
      {...props}
    />
  );
}

export default RadioGroupField;
